<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Introducer" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-introducer-form [introducer]="introducer" *ngIf="introducer"></app-introducer-form>
        </form>
      </div>
    </section>
  </div>
</div>
